module.exports = __webpack_public_path__ + "media/bootstrap-icons/basket2-fill-e17f32c9.svg";